var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        clearable: "",
        disabled: _vm.disabled,
        filterable: "",
        loading: _vm.loading,
        placeholder: _vm.placeholder,
        remote: "",
        "remote-method": _vm.fetchRecords,
        size: _vm.size
      },
      on: { change: _vm.onChanged, clear: _vm.fetchRecords },
      model: {
        value: _vm.key,
        callback: function($$v) {
          _vm.key = $$v
        },
        expression: "key"
      }
    },
    _vm._l(_vm.lookupItems, function(item) {
      return _c(
        "el-option",
        {
          key: item.id,
          attrs: { label: _vm.printLabel(item), value: item.id, size: "mini" }
        },
        [_vm._t("default", null, { item: item })],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }